import React from 'react';
import './SwitchItem.scss';
import { any, bool } from 'prop-types';

const SwitchItem = ({ children, isSelected, ...props }) => 
    <button {...props} className={isSelected ? 'selected': ''}>
        {children}
    </button>;

SwitchItem.propTypes = {
    children: any,
    isSelected: bool
}

export default SwitchItem
